/**
 * Centralised role helpers — single source of truth for "is this user
 * allowed to see admin features". Used by both Dashboard tiles, the
 * AppHeader, and any future admin gate.
 *
 * Why a flag-based helper? Christof's `role` is stored as `admin` in the
 * DB but he has the `is_super_admin: true` flag set, giving him
 * cross-tenant visibility. The startup hook may briefly re-stamp old
 * data with `role: "super_admin"` (legacy). Both should map to the same
 * UI experience.
 */
export const isAdmin = (user) =>
  !!user && (user.role === "admin" || user.role === "super_admin" || user.is_super_admin === true);

export const isDirectorOrAbove = (user) =>
  !!user && (isAdmin(user) || user.role === "sales_director");

export const isManagerOrAbove = (user) =>
  !!user && (isDirectorOrAbove(user) || user.role === "sales_manager");
